<template>
  <section>
    <main
      class="main animated fadeIn faster"
      :class="{ 'expand-main': isMenuCollapse }"
    >
      <div class="container-fluid w-100 mb-3 p-3 bg-white rounded">
        <div class="row" v-if="loading || loadingTotal">
          <div class="text-center col-12">
            <LoadingSpinner />
          </div>
        </div>
        <div class="row my-4 px-2" v-else>

          <div class="col-md-12">
            <div class="row">
              <div class="col-md-12">
                <div class="text-center">
                  <Pagination
                    v-if="!loading"
                    :total="total"
                    :totalpage="model.cantPerPage"
                    :model="model"
                    color="primary"
                    :limit="false"
                    @changePage="changePage"
                    :key="paginationkey"
                  >
                  </Pagination>
                </div>
              </div>
            </div>
            <div class="mx-0 px-0 table-responsive">
              <Table
                :cols="cols"
                :data="clients"
                :headers="simpleheader"
                :loading="loading"
                @goToAgency="goToAgency"
                @goToLinkedin="goToLinkedin"
                class="mx-2 w-100"
              />
            </div>
          </div>
        </div>
      </div>
    </main>
  </section>
</template>

<script>
import LoadingSpinner from "@/components/LoadingSpinner.vue";
import Table from "@/components/Common/Table.vue";
import Pagination from "@/components/Common/Pagination.vue";
import { clientsService } from "@/_services";

export default {
  name: "Clients",
  components: { Table, LoadingSpinner, Pagination },
  data() {
    return {
      isMenuCollapse: false,
      paginationkey: 2,
      cantPerPage: 50,
      person: 'data:image/svg+xml;base64,PHN2ZyBmaWxsPSJub25lIiBoZWlnaHQ9IjMyIiB3aWR0aD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cmVjdCB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHJ4PSIxNiIgZmlsbD0iIzkwY2FmOSIvPjxjaXJjbGUgY3g9IjE2IiBjeT0iMTIiIHI9IjUiIGZpbGw9IndoaXRlIi8+PHBhdGggZD0iTTE2IDE4Yy02LjYgMC0xMiA0LjItMTIgOXYxYzAgMS4xLjkgMiAyIDJoMjhjMS4xIDAgMi0uOSAyLTJ2LTFjMC00LjgtNS40LTktMTItOXoiIGZpbGw9IndoaXRlIi8+PC9zdmc+',
      searchFilter: {},
      clients: [],
      model: {},
      total: 0,
      loading: true,
      loadingTotal: true,
      cols: [
        [
          {
            value: "photo",
            type: "image",
          },
        ],
        [
          {
            value_label: "name",
            value_emit: "id",
            class: "text-primary",
            type: "emit",
            emit: "goToAgency",
          },
        ],
        [
          {
            value_label: "linkedin_url",
            value_emit: "linkedin_url",
            class: "text-primary",
            type: "emit",
            emit: "goToLinkedin",
          },
        ],
        [
          {
            value: "industry",
          },
        ],
      ],
      simpleheader: [
        {
          label: "Logo",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.companyname"),
          class: "overflowhide",
        },
        {
          label: "Linkedin",
          class: "overflowhide",
        },
        {
          label: this.$t("lang.label.industry"),
          class: "overflowhide",
        },
      ],
      // Add your component data here
    };
  },
  created() {
    if (this.model.cantPerPage == undefined) {
      this.model.currentPage = 1;
      this.model.cantPerPage = this.cantPerPage;
    }
    this.getClients();
  },
  methods: {
    async resolveClientPhoto(user) {
      if (String(user.has_avatar) !== "1") {
        this.$set(user, "photo", this.person);
        return;
      }

      const base64 = btoa(`usr-${user.id}`);
      const avatarUrl = `${process.env.VUE_APP_ROOT_API}/redirect/image/${base64}`;
      const isAvailable = await this.imageExists(avatarUrl);
      this.$set(user, "photo", isAvailable ? avatarUrl : this.person);
    },
    imageExists(url) {
      return new Promise((resolve) => {
        const img = new Image();
        img.onload = () => resolve(true);
        img.onerror = () => resolve(false);
        img.src = url;
      });
    },
    changePage() {
      this.getClients();
    },

    getClients() {
      this.loading = true;
      
      //this.model.searchFilter = this.searchFilter;
      clientsService
      .getBdrClients(this.model)
      .then(async (response) => {
        this.clients = response.data;
        await Promise.all(this.clients.map((user) => this.resolveClientPhoto(user)));
        this.total = response.total;
        
        this.getTotal();
        })
        .then(() => {
          this.loading = false;
        })
        .catch((error) => {
          console.error("Error fetching clients:", error);
          this.loading = false;
        });
    },
    hasPermissions(perm) {
      return this.$store.getters["authentication/hasPermissions"](perm);
    },
    goToAgency(client_id, client_name) {
      //(client_id, this.hasPermissions('isAgencyManager'), this.$store.state.authentication.user.role_id);

      if (this.hasPermissions("isBdr") || this.hasPermissions("adminAgency")) {
        let url = "/clients/" + client_id;
        window.open(url, "_blank");
      }
    },

    getTotal() {
      this.loadingTotal = true;
      this.model.getTotal = true;
      clientsService
        .getBdrClients(this.model)
        .then((response) => {
          this.total = response.total;
          this.model.getTotal = false;
          this.loadingTotal = false;
        })
        .catch((error) => {
          console.error("Error fetching clients:", error);
          this.loadingTotal = false;
        });
    },
    // Add your component methods here
    goToLinkedin(linkedin_url) {
      if (linkedin_url) {
        window.open(linkedin_url, "_blank");
      }
    },
  },
};
</script>

<style scoped>
.clients {
  /* Add your component styles here */
}
</style>
